export enum treasuryContributionFormFields {
  amount = 'amount',
}
